import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { APP_NAME } from 'utils/appConstant';

// Axios config
const config = {
  baseURL: '',
  timeout: 60000,

  // Only throw if HTTP error > 4XX
  validateStatus: function (status) {
    return status < 500;
  }
}

// Create the axios singleton
var instance = axios.create(config);

/**
 * HTTP Client
 *
 * HTTP client wrapper for normal HTTP requests
 */
export class Client {
  /**
   * Set base URL as the default for making requests
   *
   * @param {string} url
   */
  static async setBaseURL(url) {
    instance.defaults.baseURL = url;
  }

  static async setToken(token) {
    instance.defaults.headers.common["Authorization"] = token;
  }

  static async getToken() {
    const token = instance.defaults.headers.common["Authorization"];

    return token;
  }

  static async setMFAToken(token) {
    instance.defaults.headers.common["mfaToken"] = token;
  }

  static async removeTokens() {
    delete instance.defaults.headers.common["Authorization"];
    delete instance.defaults.headers.common["mfaToken"];
  }

  /**
   * Send a normal HTTP GET request
   *
   * @param {string} url Resource endpoint
   * @param {object} qs Query string
   * @param {object} config Axios config
   */
  static async get(url, qs, config) {
    try {
      const res = await axios.get(url, config);

      if (res.status !== 200)
        throw (res);

      return res.data;

    } catch (e) {
      throw (e)
    }
  }

  // static async getGz(url) {
  //   try {
  //     const res = await axios.get(url, { responseType: 'arraybuffer' });

  //     if (res.status !== 200)
  //       throw (res);

  //     return JSON.parse(pako.ungzip(res.data,{ to: 'string' }));
  //   } catch (e) {
  //     throw (e)
  //   }
  // }

  /**
   * Get data from CAST backend
   *
   * @param {object} data Query string
   */
  static async getData(url, idBool) {
    try {
      if (!instance.defaults.baseURL)
        throw Error("BaseURL not set!")

      let config = {};

      if (idBool) {
        config.headers = {
          "correlation-id": uuidv4(),
          "partner-id": APP_NAME
        };
      }

      const res = await instance.get(url, config);

      if (res.status !== 200)
        throw (res);

      return res.data;
    } catch (e) {
      throw (e)
    }
  }

  /**
   * Post data to CAST backend
   *
   * @param {object} data Query string
   */
  static async postData(url, data, idBool, opts) {
    try {
      if (!instance.defaults.baseURL)
        throw Error("BaseURL not set!")

      let config = {};

      if (idBool) {
        config.headers = {
          "correlation-id": uuidv4(),
          "partner-id": APP_NAME
        };
      }

      var res = null;

      if (undefined !== opts && opts['isListObject'] === true) {
        res = await instance.post(url, [...data], config);
      } else {
        res = await instance.post(url, { ...data }, config);
      }



      if (res.status !== 200)
        throw (res);

      return res.data;
    } catch (e) {
      throw (e)
    }
  }

  static async putData(urlFormat, data, idBool, opts) {
    try {
      if (!instance.defaults.baseURL)
        throw Error("BaseURL not set!")

      let config = {};

      if (idBool) {
        config.headers = {
          "correlation-id": uuidv4(),
          "partner-id": APP_NAME
        };
      }

      if (undefined !== opts && opts['id']) {
        urlFormat = urlFormat.replace('{0}', opts['id'])
      }

      var res = null;
      if (undefined !== opts && opts['isListObject']) {
        res = await instance.put(urlFormat, [...data], config);
      } else {
        res = await instance.put(urlFormat, { ...data }, config);
      }

      if (res.status !== 200)
        throw (res);

      return res.data;
    } catch (e) {
      throw (e)
    }
  }
  // /**
  //  * Send a normal HTTP POST request
  //  *
  //  * @param {string} url Resource endpoint
  //  * @param {object} qs Query string
  //  * @param {object} config Axios config
  //  */
  // static async post(url, data, config) {
  //   try {
  //     const res = await axios.post(url, data, config)

  //     if (res.status !== 200)
  //       throw (res);

  //     return res.data;
  //   } catch (e) {
  //     throw (e)
  //   }
  // }

  /**
   * Post data to CAST backend
   *
   * @param {object} data Query string
   */
  static async patchData(url, data, idBool) {
    try {
      if (!instance.defaults.baseURL)
        throw Error("BaseURL not set!")

      let config = {};

      if (idBool) {
        config.headers = {
          "correlation-id": uuidv4(),
          "partner-id": APP_NAME
        };
      }

      const res = await instance.patch(url, { ...data }, config);

      if (res.status !== 200)
        throw (res);

      return res.data;
    } catch (e) {
      throw (e)
    }
  }
}